import { render, staticRenderFns } from "./taxBooks.vue?vue&type=template&id=528017d8&scoped=true&"
import script from "./taxBooks.vue?vue&type=script&lang=js&"
export * from "./taxBooks.vue?vue&type=script&lang=js&"
import style0 from "./taxBooks.vue?vue&type=style&index=0&id=528017d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528017d8",
  null
  
)

export default component.exports